(function () {
  var api = window.NCHeaderWithTopbar || {};
  var lockedRoots = api.lockedRoots || [];
  var previousBodyOverflow = api.previousBodyOverflow || "";

  function hasLockedRoot(root) {
    return lockedRoots.indexOf(root) !== -1;
  }

  function lockBody(root) {
    if (hasLockedRoot(root)) return;

    if (lockedRoots.length === 0) {
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }

    lockedRoots.push(root);
    api.previousBodyOverflow = previousBodyOverflow;
    api.lockedRoots = lockedRoots;
  }

  function unlockBody(root) {
    lockedRoots = lockedRoots.filter(function (item) {
      return item !== root && document.documentElement.contains(item);
    });

    if (lockedRoots.length === 0) {
      document.body.style.overflow = previousBodyOverflow;
      previousBodyOverflow = "";
    }

    api.previousBodyOverflow = previousBodyOverflow;
    api.lockedRoots = lockedRoots;
  }

  function setSearchOpen(root, isOpen) {
    var panel = root.querySelector("[data-nc-header-search-panel]");
    var input = root.querySelector("[data-nc-header-search-input]");
    var toggles = root.querySelectorAll("[data-nc-header-search-toggle]");

    root.classList.toggle("is-search-open", isOpen);

    if (panel) {
      panel.hidden = !isOpen;
    }

    toggles.forEach(function (toggle) {
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      toggle.setAttribute("aria-label", isOpen ? "Close search" : "Open search");
    });

    if (isOpen && input) {
      window.setTimeout(function () {
        input.focus();
      }, 0);
    }
  }

  function setMobileMenuOpen(root, isOpen) {
    var panel = root.querySelector("[data-nc-header-mobile-panel]");
    var toggle = root.querySelector("[data-nc-header-menu-toggle]");
    var topLine = root.querySelector('[data-nc-header-hamburger-line="top"]');
    var middleLine = root.querySelector('[data-nc-header-hamburger-line="middle"]');
    var bottomLine = root.querySelector('[data-nc-header-hamburger-line="bottom"]');

    root.classList.toggle("is-mobile-menu-open", isOpen);

    if (panel) {
      panel.hidden = !isOpen;
    }

    if (toggle) {
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }

    if (topLine) {
      topLine.classList.toggle("nc-header-with-topbar__hamburger-line--top-open", isOpen);
    }

    if (middleLine) {
      middleLine.classList.toggle("nc-header-with-topbar__hamburger-line--middle-open", isOpen);
    }

    if (bottomLine) {
      bottomLine.classList.toggle("nc-header-with-topbar__hamburger-line--bottom-open", isOpen);
    }

    if (isOpen) {
      lockBody(root);
    } else {
      unlockBody(root);
    }
  }

  function closeRoot(root) {
    setSearchOpen(root, false);
    setMobileMenuOpen(root, false);
  }

  function initRoot(root) {
    if (!root || root.dataset.ncHeaderInitialized === "true") return;

    var menuToggle = root.querySelector("[data-nc-header-menu-toggle]");
    var searchToggles = root.querySelectorAll("[data-nc-header-search-toggle]");
    var searchClose = root.querySelector("[data-nc-header-search-close]");
    var mobileLinks = root.querySelectorAll("[data-nc-header-mobile-link]");

    root.dataset.ncHeaderInitialized = "true";

    if (menuToggle) {
      menuToggle.addEventListener("click", function () {
        setMobileMenuOpen(root, !root.classList.contains("is-mobile-menu-open"));
      });
    }

    searchToggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        setSearchOpen(root, !root.classList.contains("is-search-open"));
      });
    });

    if (searchClose) {
      searchClose.addEventListener("click", function () {
        setSearchOpen(root, false);
      });
    }

    mobileLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        setMobileMenuOpen(root, false);
      });
    });

    root.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeRoot(root);
      }
    });
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-header]")
      : [];

    if (scope.matches && scope.matches("[data-nc-header]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  api.initAll = initAll;
  api.closeRoot = closeRoot;
  api.lockedRoots = lockedRoots;
  api.previousBodyOverflow = previousBodyOverflow;
  window.NCHeaderWithTopbar = api;

  if (!window.__ncHeaderWithTopbarEventsBound) {
    window.__ncHeaderWithTopbarEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCHeaderWithTopbar.initAll(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      window.NCHeaderWithTopbar.initAll(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      var roots = event.target.querySelectorAll
        ? event.target.querySelectorAll("[data-nc-header]")
        : [];

      if (event.target.matches && event.target.matches("[data-nc-header]")) {
        window.NCHeaderWithTopbar.closeRoot(event.target);
      }

      roots.forEach(function (root) {
        window.NCHeaderWithTopbar.closeRoot(root);
      });
    });
  }

  if (document.readyState !== "loading") {
    window.NCHeaderWithTopbar.initAll(document);
  }
})();
